module.exports = "./img/28eb53247b7d7811670d2ff08c2738d8.jpg";